import WaitingFilter from "../../../api/models/WaitingFilter";
import Dictionary from "../../../models/Dictionary";

const waitingForCustomerOptions: ReadonlyArray<WaitingFilter> = ["WAITING", "NOT_WAITING", "ALL"] as const;
export const waitingForCustomerDefault = "ALL";
export const waitingForCustomerOptionsDictionary: Dictionary<WaitingFilter> = {
  ALL: "All",
  WAITING: "Waiting for Customer",
  NOT_WAITING: "Not Waiting for Customer",
};

export default waitingForCustomerOptions;
